import { Component, Input } from '@angular/core';
import { PhonePipe } from '@lsq-frontend/common-ui';
import { FieldSchema, StringFieldOption } from '@lsq-frontend/remote-services/ar-app';

@Component({
    selector: 'dr-review-field',
    styleUrls: ['./dr-review-field.component.scss'],
    templateUrl: './dr-review-field.component.html'
})
export class ReviewField {
    @Input() fieldSchema: FieldSchema;
    @Input() field: { fieldValue: any };
    @Input() adminMode: boolean;

    constructor(private phonePipe: PhonePipe) {}

    public parseFieldValue(): string {
        const fieldOptions = this.fieldSchema.fieldOption as StringFieldOption;
        if (fieldOptions.inputType === StringFieldOption.InputTypeEnum.Tel) {
            return this.phonePipe.transform(this.field.fieldValue) || '--';
        }
        return this.field.fieldValue || '--';
    }
}
